import ManageClassroom from './BrowserView';

export default ManageClassroom;
